<template>
  <v-scale-transition>
    <v-container>
      <v-layout column>
        <v-flex xs12>
          <h3 class="headline grey--text text-xs-center">
            Dashboard: Signage
          </h3>
        </v-flex>
        <v-flex xs12>
          <v-sheet
            class="transparent"
            height="300"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-scale-transition>
</template>

<script>
import security from '@/security'

export default {
  created: function () {
    const properties = security.me.getProperties()
    let url = '/signage/schedule'

    properties.forEach(property => {
      if (property.name === 'dashboard.signage' && property.value === 'admin') {
        url = '/signage/administration'
      }
    })

    this.$router.push(url)
  },
}
</script>
